import * as types from "~/store/partnerUser/types";

export const createPartnerUser = (id, partnerId) => {
  return {
    type: types.CREATE_PARTNER_USER,
    id,
    partnerId
  };
};
